import { createContext } from "react";

export const JsonDataContext = createContext(null);